<template>
  <adminTable
    :hideResetButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
  <template v-slot:form-inline-items>
      <el-form-item>
        <el-input
          v-model="searchForm.username"
          placeholder="请输入用户名"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入电话号码"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.is_test"
          placeholder="请选择账号类型"
          clearable
        >
          <el-option
            v-for="item in accountTypeEnums"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      

      <el-form-item>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            placeholder="结束时间"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
          />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.id }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.uid }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号码" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="lv_id" label="团队ID" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.lv_id }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="lv_name" label="团队名称" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.lv_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="账号类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="gift_time" label="团队礼品发放时间" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.gift_time }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="bonus" label="团队奖金" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.bonus }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="创建时间" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.create_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="update_at" label="更新时间" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.update_at }}
          </span>
        </template>
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { userLevelTypeEnums, accountTypeEnums, getLabelByVal } from "../../config/enums";

const searchForm = ref({
  username: "",
  phone: "",
  is_test: "",
  starttime: "",
  endtime: "",
});

onMounted(() => {
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Team/getTeamGiftLists",
    params: {
      ...searchForm.value,
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
